import axios from 'axios';
//THIS IS WEBSITE HOMEPAGES AND OTHER PAGES API BASE
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  // base_UAT_API_URL: 'http://modiwaydevenv-1402653312.ap-south-1.elb.amazonaws.com:3000/api',
  // base_UAT_API_URL: 'http://modiwaydevenv-1402653312.ap-south-1.elb.amazonaws.com:3000/api',
  timeout: 30000,
});

export default {
  install: (app) => {
    app.config.globalProperties.$axios = axiosInstance;
    app.provide('axios', axiosInstance);
  },
};
export { axiosInstance };
